import { Button } from "@tento-ui/components/button/button";
import { Toast } from "@tento-ui/components/toast/toast";
import { Storybook } from "@tento-ui/ui/storybook";
import {
  RecurringEditAction,
  RecurringEditModal,
} from "@tento-ui/components/calendar/delete-recurring-event-modal";

export class DeleteRecurringEventModalStoryBook extends Storybook.Default {
  title(): string {
    return "Recurring Edit Modal";
  }

  examples(): Storybook.Example[] {
    const actions: RecurringEditAction[] = ["delete", "move", "resize"];
    const examples: Storybook.Example[] = [];

    for (const action of actions) {
      examples.push({
        title: `${capitalize(action)} — Inline`,
        render: () =>
          RecurringEditModal.make().bind(
            action,
            "Weekly Team Meeting",
            (option) => {
              Toast.info(`${action}: ${option}`);
            },
          ),
      });
      examples.push({
        title: `${capitalize(action)} — Show`,
        render: () =>
          Button.makeWithLight(`${capitalize(action)} Recurring Event`, {
            type: "primary",
            onClick: () => {
              RecurringEditModal.show(action, "Weekly Team Meeting", (option) => {
                Toast.info(`${action}: ${option}`);
              });
            },
          }),
      });
    }

    return examples;
  }
}

function capitalize(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1);
}
